import { getAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";

export function getRetrieveSavedVeridasCall(callback: Function, errorCallback: Function,customerId:any) {
    const apiWithParams = `/veridas/token/${customerId}`;
    getAxios(apiNames.PROFMANAG, false, apiWithParams).then((data: any) => {
      callback(data.data);
    }).catch((error: any) => {
      errorCallback(error)
    })
  }
